export default {
  getMini: (state) => {
    return state.mini;
  },
  getPultsList: (state) => {
    return state.pults;
  },
  getCurrentDate: (state) => {
    return state.curDate;
  },
  getFromDate: (state) => {
    return state.dateFrom;
  },
  getToDate: (state) => {
    return state.dateTo;
  },
  getPult: (state) => {
    return state.pult;
  },
  getUser: (state) => {
    return state.user;
  },
  getAgent: (state) => {
    return state.agent;
  },
  getRoles: (state) => {
    return state.roles;
  },
  isAdmin: (state) => {
    return state.roles ? state.roles.includes("6") : false;
  },
  getGroup: (state) => {
    return state.group;
  },
  getCashier: (state) => {
    return state.cashier;
  },
  getSnack: (state) => {
    return state.snack;
  },
  getDialog: (state) => {
    return state.dialog;
  },
  getDialogStatus: (state) => {
    return state.dialogStatus;
  },
  getBlank: (state) => {
    return state.blank;
  },
  getOrder: (state) => {
    return state.order;
  },
  getGridFilterOn: (state) => {
    return state.gridFilterOn;
  },
  getFilteredData: (state) => {
    return state.filteredData;
  },
  getSearchValue: (state) => {
    return state.searchValue;
  },
  getLoading: (state) => {
    return state.loading;
  },
  getOrderParams: (state) => {
    return state.orderParams;
  },
  getBlankParams: (state) => {
    return state.blankParams;
  },
  getServicesList: (state) => {
    return state.servicesList;
  },
  getFopList: (state) => {
    return state.fopList;
  },
  getCommonBarScreenParseDialog: (state) => state.commonBarScreenParseDialog,
  getDocumentsAssignCashierDialog: (state) => {
    return state.documentsAssignCashierDialog;
  },
  getCashierList: (state) => {
    return state.cashierList;
  },
  getDocumentsList: (state) => {
    return state.documentsList;
  },
  getDocumentsDeep: (state) => {
    return state.documentsDeep;
  },
  getPayCodes: (state) => {
    return state.payCodes;
  },
  getPayTypes: (state) => {
    return state.payTypes;
  },
  getRowData: (state) => {
    return state.rowData;
  },
  getMainMenu: (state) => {
    return state.mainMenu;
  },
  getSettingsMenu: (state) => {
    return state.settingsMenu;
  },
  getInsurance: (state) => {
    return state.insurance;
  },
  getInsuranceParams: (state) => {
    return state.insuranceParams;
  },
  getTokenForOld: (state) => {
    return state.tokenForOld;
  },
  getGridFilters: (state) => {
    return state.gridFilters;
  },
  getCurrentGrid: (state) => {
    return state.currentGrid;
  },
  getDailyReports: (state) => state.dailyReports,
  getParsersList: (state) => state.parsersList,
  getReportNewVersionAccess: (state) => state.reportNewVersionAccess,
  getExternalFilterDialog: (state) => state.externalFilterDialog,
  getFilteredColumns: (state) => state.filteredColumns,
  getPeriodClients: (state) => state.periodClients,
  getFilteredClients: (state) => state.filteredClients,
  getColumnsOnGrid: (state) => {
    return state.columnsOnGrid;
  },
  getReportsAdditionalList: (state) => {
    return state.reportsAdditionalList;
  },
  getCurrentAdditionalReport: (state) => {
    return state.currentAdditionalReport;
  },
  getAdditionalTableTemplates: (state) => {
    return state.additionalTableTemplates;
  },
  getAdditionalReportData: (state) => state.additionalReportData,
};
